import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { QuickWebLoggerModule } from './app/core/util/dataDog/quickWebLogger';

if (environment.production) {
  enableProdMode();
}

QuickWebLoggerModule.init({
  name: environment.quickWebLogger.name,
  version: environment.quickWebLogger.version,
  env: environment.quickWebLogger.env,
  sigla: environment.quickWebLogger.sigla,
  externalApplication: environment.quickWebLogger.externalApplication,
  clientToken: environment.quickWebLogger.datadog.logs.clientToken,
  applicationId: environment.quickWebLogger.datadog.rum.applicationId,

  sessionSampleRate: environment.quickWebLogger.datadog.rum.sessionSampleRate,
  maskSensitiveData: environment.quickWebLogger.datadog.rum.maskSensitiveData,
  allowedTracingUrls: environment.quickWebLogger.datadog.rum.allowedTracingUrls,
  traceSampleRate: environment.quickWebLogger.datadog.rum.traceSampleRate,
  trackLongTasks: environment.quickWebLogger.datadog.rum.trackLongTasks,
  trackResources: environment.quickWebLogger.datadog.rum.trackResources,
  trackUserInteraction: environment.quickWebLogger.datadog.rum.trackUserInteraction
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
